<template>
  <!-- Add Customer -->
  <div class="modal fade" id="add-units">
    <div class="modal-dialog add-centered">
      <div class="modal-content">
        <div class="page-wrapper-new p-0">
          <div class="content">
            <div
              class="modal-header border-0 custom-modal-header justify-content-between"
            >
              <div class="page-title">
                <h4>Ajouter un nouveau Employé</h4>
              </div>
              <button
                type="button"
                class="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body custom-modal-body">
              <form @submit.prevent="submitForm">
                <div class="row">
                  <div class="col-12">
                    <div class="employee-photo-field mb-3">
                      <div class="employee-photo-preview">
                        <img v-if="addImagePreview" :src="addImagePreview" alt="Aperçu" />
                        <vue-feather v-else type="user" size="26"></vue-feather>
                      </div>
                      <div class="flex-grow-1">
                        <label class="form-label mb-1">Photo de profil <span class="text-muted">(optionnelle)</span></label>
                        <input class="form-control" type="file" accept="image/jpeg,image/png,image/webp" @change="handleImageChange($event, 'create')" />
                        <small class="text-muted">JPG, PNG ou WEBP — 2 Mo maximum</small>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Nom Complet</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="form.name"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-lg-6 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Email</label>
                      <input
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': emailError }"
                        v-model="form.email"
                        @blur="validateEmployeeEmail('create')"
                        required
                      />
                      <div v-if="emailError" class="invalid-feedback d-block">
                        {{ emailError }}
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Mot de passe</label>
                      <input
                        class="form-control form-control-lg group_formcontrol"
                        type="password"
                        v-model="form.password"
                        required
                      />

                      <p class="mt-1 form-label">
                        Le mot de passe est
                        <span style="color: red">12345678</span> par défaut
                      </p>
                    </div>
                  </div>
                  <div class="col-lg-6 pe-0">
                    <div class="mb-3">
                      <label class="form-label"
                        >Confirmer le mot de passe</label
                      >
                      <input
                        class="form-control form-control-lg group_formcontrol"
                        type="password"
                        v-model="form.confirmPassowrd"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-lg-12 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Role</label>
                      <vue-select
                        :options="rolesOptions"
                        id="choosecuss"
                        placeholder="Choose"
                        v-model="form.role"
                      />
                    </div>
                  </div>
                </div>

                <div class="modal-footer-btn">
                  <button
                    type="button"
                    class="btn btn-cancel me-2"
                    data-bs-dismiss="modal"
                  >
                    Annuler
                  </button>
                  <button type="submit" class="btn btn-submit">
                    Confirmer
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Add Customer -->

  <!-- Edit Customer -->
  <div class="modal fade" id="edit-units">
    <div class="modal-dialog add-centered">
      <div class="modal-content">
        <div class="page-wrapper-new p-0">
          <div class="content">
            <div
              class="modal-header border-0 custom-modal-header justify-content-between"
            >
              <div class="page-title">
                <h4>Modifier un Employé</h4>
              </div>
              <button
                type="button"
                class="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body custom-modal-body">
              <form @submit.prevent="submitForm1">
                <div class="row">
                  <div class="col-12">
                    <div class="employee-photo-field mb-3">
                      <div class="employee-photo-preview">
                        <img v-if="editImagePreview" :src="editImagePreview" alt="Aperçu" />
                        <vue-feather v-else type="user" size="26"></vue-feather>
                      </div>
                      <div class="flex-grow-1">
                        <label class="form-label mb-1">Photo de profil <span class="text-muted">(optionnelle)</span></label>
                        <input class="form-control" type="file" accept="image/jpeg,image/png,image/webp" @change="handleImageChange($event, 'edit')" />
                        <small class="text-muted">Laissez vide pour conserver la photo actuelle</small>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Nom Complet</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="form1.name"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-lg-6 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Email</label>
                      <input
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': emailErrorEdit }"
                        v-model="form1.email"
                        @blur="validateEmployeeEmail('edit')"
                        required
                      />
                      <div
                        v-if="emailErrorEdit"
                        class="invalid-feedback d-block"
                      >
                        {{ emailErrorEdit }}
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Mot de passe</label>
                      <input
                        class="form-control form-control-lg group_formcontrol"
                        type="password"
                        v-model="form1.password"
                      />
                    </div>
                  </div>
                  <div class="col-lg-6 pe-0">
                    <div class="mb-3">
                      <label class="form-label"
                        >Confirmer le mot de passe</label
                      >
                      <input
                        class="form-control form-control-lg group_formcontrol"
                        type="password"
                        v-model="form1.confirmPassowrd"
                      />
                    </div>
                  </div>
                  <div class="col-lg-12 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Role</label>
                      <vue-select
                        :options="roles"
                        id="choosecussmp"
                        placeholder="Choose"
                        v-model="form1.role"
                        :disabled="form1.role === 'Admin'"
                      />
                    </div>
                  </div>
                </div>

                <div class="modal-footer-btn">
                  <button
                    type="button"
                    class="btn btn-cancel me-2"
                    data-bs-dismiss="modal"
                  >
                    Annuler
                  </button>
                  <button type="submit" class="btn btn-submit">
                    Confirmer
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Edit Customer -->
</template>
<script>
import {
  createEmployee,
  updateEmployee,
  checkEmployeeEmail,
} from "@/services/emplooyesService";
import { Modal } from "bootstrap";
import { decodeToken } from "@/services/jwtService";
import villesData from "@/assets/ville.json";
import { toast } from "vue3-toastify";
import { getRoles } from "@/services/roleService";

export default {
  props: {
    data: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    remainingAdmins: {
      type: Number,
      required: false,
      default: null,
    },
    remainingUsers: {
      type: Number,
      required: false,
      default: null,
    },
    maxUsers: {
      type: Number,
      required: false,
      default: null,
    },
    maxAdmins: {
      type: Number,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      form: {
        name: "",
        email: "",
        password: "12345678",
        confirmPassowrd: "12345678",
        role: "",
      },
      form1: {
        id: null,
        name: "",
        email: "",
        password: "",
        confirmPassowrd: "",
        role: "",
      },
      roles: [],
      roleRecords: [],
      ClientsType: ["FOURNISSEUR", "CLIENT", "PROSPECT"],
      Types: ["INDIVIDUAL", "COMPANY"],
      Civilite: ["M", "MME"],
      ChooseCusOne: ["Varrel", "Varrel"],
      ChooseCityOne: ["Germany", "United State"],
      villesData,
      emailError: "",
      emailErrorEdit: "",
      emailCheckTimer: null,
      emailCheckTimerEdit: null,
      addImageFile: null,
      addImagePreview: "",
      editImageFile: null,
      editImagePreview: "",
    };
  },
  computed: {
    rolesOptions() {
      if (this.remainingAdmins !== null && this.remainingAdmins <= 0) {
        return this.roles.filter((role) => role !== "Admin");
      }
      return this.roles;
    },
  },
  methods: {
    profileImageUrl(path) {
      if (!path) return "";
      if (/^(https?:\/\/|data:image\/|blob:)/i.test(path)) return path;
      const base = (process.env.VUE_APP_URL || window.location.origin).replace(/\/$/, "");
      return `${base}/storage/${String(path).replace(/^\/?storage\//, "")}`;
    },
    handleImageChange(event, mode) {
      const file = event.target.files?.[0] || null;
      if (file && file.size > 2 * 1024 * 1024) {
        event.target.value = "";
        return toast.error("La photo ne doit pas dépasser 2 Mo.");
      }
      const preview = file ? URL.createObjectURL(file) : "";
      if (mode === "create") {
        this.addImageFile = file;
        this.addImagePreview = preview;
      } else {
        this.editImageFile = file;
        this.editImagePreview = preview || this.profileImageUrl(this.data?.profile_image);
      }
    },
    scheduleEmployeeEmailCheck(mode = "create") {
      const timerKey = mode === "create" ? "emailCheckTimer" : "emailCheckTimerEdit";
      const errorField = mode === "create" ? "emailError" : "emailErrorEdit";
      const email = mode === "create" ? this.form.email : this.form1.email;

      if (this[timerKey]) {
        clearTimeout(this[timerKey]);
        this[timerKey] = null;
      }

      if (!email) {
        this[errorField] = "";
        return;
      }

      this[timerKey] = setTimeout(() => {
        this.validateEmployeeEmail(mode);
      }, 400);
    },
    async validateEmployeeEmail(mode = "create") {
      const target = mode === "create" ? this.form : this.form1;
      const errorField = mode === "create" ? "emailError" : "emailErrorEdit";
      const email = (target.email || "").trim();
      const ignoreId = mode === "edit" ? this.form1.id : null;

      if (!email) {
        this[errorField] = "";
        return true;
      }

      try {
        const result = await checkEmployeeEmail(email, ignoreId);
        const available = result?.data?.available ?? true;
        this[errorField] = available ? "" : "Cet email est déjà utilisé.";
        return available;
      } catch (error) {
        console.error(error);
        this[errorField] = "";
        return true;
      }
    },
    getFriendlyError(error) {
      try {
        const data = error && error.response && error.response.data ? error.response.data : {};
        const raw = `${data.message || ''} ${data.error || ''}`.toLowerCase();
        // Detect subscription admin limit errors from backend (SQLSTATE 45000 or custom msg)
        if (
          raw.includes('limite') &&
          (raw.includes('administrateur') || raw.includes('administrateurs'))
        ) {
          return "Limite atteinte: votre abonnement ne permet plus d’ajouter d’administrateurs. Convertissez un administrateur en employé ou contactez le support pour changer d’abonnement.";
        }
        // Detect total users limit (e.g., "Limite totale d utilisateurs atteinte")
        if (
          (raw.includes("limite totale") || raw.includes("limite d'utilisateur") || raw.includes("limite d utilisateurs") || raw.includes("limite utilisateurs")) &&
          (raw.includes("utilisateur") || raw.includes("utilisateurs"))
        ) {
          // Try to extract a number if present in the error string
          const match = raw.match(/\b(\d{1,3})\b/);
          const max = match ? match[1] : null;
          return max
            ? `Limite atteinte: votre abonnement inclut ${max} utilisateur(s). Supprimez un utilisateur existant ou contactez le support pour changer d’abonnement.`
            : "Limite atteinte: votre abonnement ne permet plus d’ajouter d’utilisateurs. Supprimez un utilisateur existant ou contactez le support pour changer d’abonnement.";
        }
        if (data.message) return data.message;
        if (data.error) return data.error;
        if (error && error.message) return error.message;
      } catch (_) { /* ignore parsing errors */ }
      return "Une erreur est survenue lors de la création de l'utilisateur.";
    },
    async submitForm() {
      try {
        let user = decodeToken(localStorage.getItem("access_token"));
        this.form.societe_id = user.societe_id;
        // Client-side enforcement of limits
        if (this.remainingUsers !== null && this.remainingUsers <= 0) {
          const max = this.maxUsers;
          const msg = max
            ? `Limite atteinte: votre abonnement inclut ${max} utilisateur(s). Supprimez un utilisateur existant ou contactez le support pour changer d’abonnement.`
            : "Limite atteinte: votre abonnement ne permet plus d’ajouter d’utilisateurs. Supprimez un utilisateur existant ou contactez le support pour changer d’abonnement.";
          return toast.error(msg);
        }
        if (this.form.role === 'Admin' && this.remainingAdmins !== null && this.remainingAdmins <= 0) {
          const maxA = this.maxAdmins;
          const msgA = maxA
            ? `Limite atteinte: votre abonnement inclut ${maxA} administrateur(s). Convertissez un administrateur en employé ou contactez le support pour changer d’abonnement.`
            : "Limite atteinte: votre abonnement ne permet plus d’ajouter d’administrateurs. Convertissez un administrateur en employé ou contactez le support pour changer d’abonnement.";
          return toast.error(msgA);
        }
        const emailAvailable = await this.validateEmployeeEmail("create");
        if (!emailAvailable) {
          return toast.error(this.emailError || "Cet email est déjà utilisé.");
        }
        const response = await createEmployee({
          name: this.form.name,
          societe_id: this.form.societe_id,
          email: this.form.email,
          password: this.form.password,
          role_id: this.roleRecords.find((role) => role.role === this.form.role)?.id,
          profile_image: this.addImageFile,
        });
        this.form.name = "";
        this.form.email = "";
        this.form.password = "";
        this.form.confirmPassowrd = "";
        this.form.role = "";
        this.addImageFile = null;
        this.addImagePreview = "";
        this.emailError = "";
        this.$emit("client-added", response);

        const modalElement = document.getElementById("add-units");
        const modal =
          Modal.getInstance(modalElement) || new Modal(modalElement);
        modal.hide();
      } catch (error) {
        console.error(error);
        toast.error(this.getFriendlyError(error));
      }
    },
    async submitForm1() {
      try {
        let user = decodeToken(localStorage.getItem("access_token"));
        this.form1.societe_id = user.societe_id;
        const emailAvailable = await this.validateEmployeeEmail("edit");
        if (!emailAvailable) {
          return toast.error(this.emailErrorEdit || "Cet email est déjà utilisé.");
        }
        const response = await updateEmployee(this.form1.id, {
          name: this.form1.name,
          societe_id: this.form1.societe_id,
          email: this.form1.email,
          // password: this.form1.password,
          role_id: this.roleRecords.find((role) => role.role === this.form1.role)?.id,
          profile_image: this.editImageFile,
        });
        this.$emit("client-updated", response);
        this.emailErrorEdit = "";

        const modalElement = document.getElementById("edit-units");
        const modal =
          Modal.getInstance(modalElement) || new Modal(modalElement);
        modal.hide();
      } catch (error) {
        console.error(error);
        toast.error(this.getFriendlyError(error));
      }
    },
  },
  watch: {
    data: {
      immediate: true,
      handler(newData) {
        this.form1.id = newData.id;
        this.form1.name = newData?.name || "";
        this.form1.email = newData?.email || "";
        this.form1.password = newData?.password || "";
        this.form1.confirmPassowrd = newData?.password || "";
        this.form1.role = newData?.role || "";
        this.editImageFile = null;
        this.editImagePreview = this.profileImageUrl(newData?.profile_image);
        this.emailErrorEdit = "";
      },
    },
    "form.email"(value) {
      if (!value) {
        this.emailError = "";
      }
      this.scheduleEmployeeEmailCheck("create");
    },
    "form1.email"(value) {
      if (!value) {
        this.emailErrorEdit = "";
      }
      this.scheduleEmployeeEmailCheck("edit");
    },
  },
  beforeUnmount() {
    if (this.emailCheckTimer) {
      clearTimeout(this.emailCheckTimer);
    }
    if (this.emailCheckTimerEdit) {
      clearTimeout(this.emailCheckTimerEdit);
    }
  },
  async mounted() {
    try {
      this.roleRecords = await getRoles();
      this.roles = this.roleRecords.map((role) => role.role);
    } catch (error) {
      toast.error(error.response?.data?.message || "Impossible de charger les rôles.");
    }
  },
};
</script>

<style scoped>
.employee-photo-field {
  align-items: center;
  background: #f8fafc;
  border: 1px dashed #cbd5e1;
  border-radius: 12px;
  display: flex;
  gap: 14px;
  padding: 14px;
}

.employee-photo-preview {
  align-items: center;
  background: #eaf1fb;
  border-radius: 50%;
  color: #64748b;
  display: flex;
  flex: 0 0 64px;
  height: 64px;
  justify-content: center;
  overflow: hidden;
  width: 64px;
}

.employee-photo-preview img {
  height: 100%;
  object-fit: cover;
  width: 100%;
}
</style>
